export const API = {
    GET_PO_ORDERS: '/api/v1/ProductHeaderItemMaster/GetPOOrders',
    GET_PO_ORDER_BY_ID: '/api/v1/ProductHeaderItemMaster/GetPoProcessOrders',
    VIEW_DOC_PO_ORDER: '/api/v1/ProductHeaderItemMaster/GeneratePoInvoice'
}